import React, { useState, useEffect } from "react";
import getDebug from "debug";

import Modal from "@components/shared/Modal";
import { useCurrentDealSelector } from "@redux/reducers/deal";
import { useAppConfigSelector } from "@redux/reducers/appConfig";
import api from "@api";

const debug = getDebug("app:development:MOPInspectorModal");

const MOPInspectorModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mopContent, setMopContent] = useState(null);

  const currentDeal = useCurrentDealSelector();
  const appConfig = useAppConfigSelector();

  useEffect(() => {
    window.__displayCurrentMopDetail = async (logOnly = false) => {
      if (!currentDeal.token) {
        debug(
          `❗️ Couldn't fetch current MOP ID because there is not any current deal token in Redux!`
        );

        return;
      }

      debug(`⏳ Fetching MOP ID for deal '${currentDeal.token}'`);

      const { data: deal } = await api.getDeal(currentDeal.token);

      debug(`✅ Successfully fetched MOP ID '${deal.externalId}'`);

      debug(`⏳ Fetching content of MOP '${deal.externalId}'`);

      const { data: mop } = await api.getMopRecord(
        appConfig.configuration.brandCode,
        appConfig.configuration.country,
        deal.externalId
      );

      debug(`✅ Successfully fetched content of MOP '${deal.externalId}'`);

      console.log(mop);

      if (!logOnly) {
        setMopContent(mop);
        setIsModalOpen(true);
      }
      return mop;
    };
  }, [currentDeal?.token]);

  return (
    <Modal
      isOpen={isModalOpen}
      ariaLabel={"MOPInspectorModal"}
      onClose={() => setIsModalOpen(false)}
      className="!w-[80dvw] !h-[80dvh] !p-1"
      doNotRenderInvisible
    >
      <pre>{JSON.stringify(mopContent, null, 2)}</pre>
    </Modal>
  );
};

export default MOPInspectorModal;
